import React from 'react';
import { Spacer } from '@ontruck/orc';
import { t_stop } from 'redux/modules/log/renderer/shipperOrderRenderer/utils/constants';
import FormattedDate from 'redux/modules/log/renderer/shipperOrderRenderer/utils/FormattedDate';

const t = {
  stop: 'Stop',
  time_window: 'Time window',
};

const updateAppointmentRenderer = ({ changes }) => {
  const getStopLabel = (stop) => `${t_stop.types[stop.stop_type?.after]} — ${stop.label?.after}`;
  return (
    <div data-testid="update-appointment-renderer">
      {changes?.stops?.map((stop, key) => {
        if (!stop.appointment?.time_from?.changed && !stop.appointment?.time_to?.changed) {
          return null;
        }
        return (
          <Spacer mTop="XS">
            <strong key={key}>{getStopLabel(stop)}</strong>
            <div data-testid={`stop-${key}`}>
              {`${t.time_window}: `}
              <FormattedDate
                timeFrom={stop.appointment.time_from?.after}
                tzFrom={stop.time_from_tz?.after}
                timeTo={stop.appointment.time_to?.after}
                tzTo={stop.time_to_tz?.after}
              />
            </div>
          </Spacer>
        );
      })}
    </div>
  );
};

export default updateAppointmentRenderer;
